import { PlusIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';
import { useProduct } from '../product/product-context';
import type { Product, ProductVariant } from 'lib/burokshop/types';
import { useCart } from './cart-context';

export function AddToCart({ product }: { product: Product }) {
  const { variants, availableForSale } = product;
  const { addCartItem } = useCart();
  const { state } = useProduct();
  const [loading, setLoading] = useState(false);

  const variant = variants.find((variant: ProductVariant) =>
    variant.selectedOptions.every(
      (option) => option.value === state[option.name.toLowerCase()]
    )
  );
  const defaultVariantId = variants.length === 1 ? variants[0]?.id : undefined;
  const selectedVariantId = variant?.id || defaultVariantId;
  const finalVariant = variants.find(
    (variant) => variant.id === selectedVariantId
  )!;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedVariantId || !finalVariant) return;
    
    setLoading(true);
    try {
      await addCartItem(finalVariant);
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <button
        type="submit"
        disabled={!availableForSale || !selectedVariantId || loading}
        className={clsx(
          'relative flex w-full items-center justify-center rounded-full bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 p-4 tracking-wide text-white shadow-md transition-all',
          {
            'cursor-not-allowed opacity-60 hover:opacity-60': !availableForSale || !selectedVariantId || loading,
            'hover:from-blue-600 hover:via-blue-700 hover:to-indigo-700 hover:shadow-lg': availableForSale && selectedVariantId && !loading
          }
        )}
        aria-label={!selectedVariantId ? 'Please select an option' : 'Add to cart'}
      >
        <div className="absolute left-0 ml-4">
          <PlusIcon className="h-5" />
        </div>
        {!availableForSale
          ? 'Out Of Stock'
          : !selectedVariantId
          ? 'Please select an option'
          : loading
          ? 'Adding...'
          : 'Add To Cart'}
      </button>
    </form>
  );
}



